import React from "react";
import DataTable from "react-data-table-component";

const ReactDataTable = ({ columns, data }) => {
  const paginationComponentOptions = {
    rowsPerPageText: false,
    rangeSeparatorText: "of",
    selectAllRowsItem: false,
  };

  const paginationPerPage = 5;

  const paginationRowsPerPageOptions = [5, 8, 10, 15, 20, 30];

  const customStyles = {
    table: {
      style: {
        backgroundColor: "#181C26",
        borderRadius: "1px",
        overflow: "hidden",
        border: "1px solid #1f2535",
      },
    },
    rows: {
      style: {
        minHeight: "64px",
        backgroundColor: "#181C26",
        borderRight: "none",
        "&:not(:last-of-type)": {
          borderBottomStyle: "solid",
          borderBottomWidth: "1px",
          borderBottomColor: "#1f2535",
        },
        "&:hover": {
          backgroundColor: "#0d1017",
        },
      },
    },
    headCells: {
      style: {
        backgroundColor: "#0d1017",
        color: "#A9ABAD",
        fontSize: "11px",
        fontWeight: "600",
        textTransform: "uppercase",
        letterSpacing: "0.08em",
        borderBottom: "1px solid #1f2535",
      },
    },
    cells: {
      style: {
        backgroundColor: "transparent",
        color: "#cacbcb",
        fontSize: "13px",
      },
    },
    pagination: {
      style: {
        backgroundColor: "#181C26",
        color: "#A9ABAD",
        borderTop: "1px solid #1f2535",
        fontSize: "13px",
      },
      pageButtonsStyle: {
        borderRadius: "8px",
        height: "32px",
        width: "32px",
        padding: "4px",
        cursor: "pointer",
        transition: "0.2s",
        color: "#A9ABAD",
        fill: "#A9ABAD",
        backgroundColor: "transparent",
        "&:disabled": {
          cursor: "unset",
          opacity: "0.3",
          fill: "#A9ABAD",
        },
        "&:hover:not(:disabled)": {
          backgroundColor: "#1f2535",
          fill: "white",
        },
        "&:focus": {
          outline: "none",
          backgroundColor: "#1f2535",
        },
      },
    },

    noData: {
      style: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#A9ABAD",
        textAlign: "center",
        backgroundColor: "#181C26",
        padding: "3rem",
      },
    },
  };

  return (
    <div className="relative w-full min-h-[100px] overflow-x-auto">
      <div className="min-w-[600px]">
        <DataTable
          className=""
          columns={columns}
          data={data}
          customStyles={customStyles}
          pagination
          paginationComponentOptions={paginationComponentOptions}
          paginationRowsPerPageOptions={paginationRowsPerPageOptions}
          paginationPerPage={paginationPerPage}
        />
      </div>
    </div>
  );
};

export default ReactDataTable;
